import { useHierarchicalMenu } from "react-instantsearch";
import { getSelectedCategoryData } from "../categories";
import { GetSearchProps_categories } from "../../components/pages/SearchPage/queries/types/GetSearchProps";

export const categoryAttributeLevel0 = "category_hierarchy.lvl0";
export const categoryAttributeLevel1 = "category_hierarchy.lvl1";

export const categoryRefinementAttributes = [categoryAttributeLevel0, categoryAttributeLevel1];

export const useSelectedCategory = () => {
  const { items } = useHierarchicalMenu({ attributes: categoryRefinementAttributes });
  const selectedItemLevel1 = items.find(({ isRefined }) => isRefined);
  const selectedItemLevel2 = selectedItemLevel1?.data?.find(({ isRefined }) => isRefined);
  const selectedItem = selectedItemLevel2 || selectedItemLevel1;
  return { selectedItem };
};

export const useCategoryRouter = (categories: GetSearchProps_categories[]) => {
  function mapCategoryStateToRoute(indexUiState: any) {
    const { hierarchicalMenu } = indexUiState;

    return hierarchicalMenu?.[categoryAttributeLevel0]?.slice(-1)[0];
  }

  function mapCategoryRouteToState(category: string) {
    const hierarchy = [];
    const { selectedParentCategory, selectedChildCategory } = getSelectedCategoryData(
      categories,
      category
    );

    if (selectedParentCategory) {
      hierarchy.push(selectedParentCategory.url);
      if (selectedChildCategory) {
        hierarchy.push(selectedChildCategory.url);
      }
    }

    if (hierarchy.length) {
      return {
        [categoryAttributeLevel0]: hierarchy,
      };
    }

    return undefined;
  }

  return { mapCategoryStateToRoute, mapCategoryRouteToState };
};
